export const isDesktopApp =
  typeof window !== 'undefined'
    ? navigator?.userAgent?.includes('MoisesDesktop') ||
      (navigator?.userAgent?.includes('Moises') &&
        navigator?.userAgent?.includes('Electron'))
    : false
